'use strict';

exports.__esModule = true;
exports.ButtonText = exports.ButtonLink = exports.BackButtonContainer = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n  transition: transform 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n  svg {\n    font-size: 22px;\n    color: ', ';\n    transition: color 0.15s ease;\n  }\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: ', ';\n    svg {\n      color: ', ';\n    }\n  }\n  @media ', ' {\n    padding: ', ';\n  }\n  @media ', ' {\n    padding: ', ';\n    svg {\n      font-size: 16px;\n    }\n  }\n'], ['\n  background-color: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n  transition: transform 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n  svg {\n    font-size: 22px;\n    color: ', ';\n    transition: color 0.15s ease;\n  }\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: ', ';\n    svg {\n      color: ', ';\n    }\n  }\n  @media ', ' {\n    padding: ', ';\n  }\n  @media ', ' {\n    padding: ', ';\n    svg {\n      font-size: 16px;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 24px;\n  font-weight: ', ';\n  margin-left: ', ';\n  @media ', ' {\n    font-size: 18px;\n  }\n  @media ', ' {\n    font-size: 16px;\n    margin-left: ', ';\n  }\n'], ['\n  color: ', ';\n  font-size: 24px;\n  font-weight: ', ';\n  margin-left: ', ';\n  @media ', ' {\n    font-size: 18px;\n  }\n  @media ', ' {\n    font-size: 16px;\n    margin-left: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterDom = require('react-router-dom');

var _device = require('../../styles/device');

var _spacing = require('../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var BackButtonContainer = exports.BackButtonContainer = _styledComponents2.default.div(_templateObject);

// De-square + auf die Button-Linie heben: radiusMd statt eckigem 3px, weiche
// elevationSm-Ruhelage statt flachem 0 3px 6px, echter Hover-Lift (translateY +
// elevationMd) wie ButtonStyled.getHoverStyle, snappigere Transition (war all 0.5s).
// Navy-Text (ButtonText) + svg-Farbwechsel bleiben. Focus-Ring kommt zentral mit
// dem Focus-Mixin (Welle 2).
var ButtonLink = exports.ButtonLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return theme.white;
}, (0, _spacing.space)(16, 30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.radiusMd || theme.borderRadiusDefault;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.elevationSm || '0 3px 6px rgba(0, 0, 0, 0.16)';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.grayA0;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.elevationMd || '0 6px 16px rgba(0, 0, 0, 0.18)';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.textColor;
}, _device.device.tablet, (0, _spacing.space)(10, 24), _device.device.mobile, (0, _spacing.space)(4, 15));

var ButtonText = exports.ButtonText = _styledComponents2.default.div(_templateObject3, function (_ref7) {
  var theme = _ref7.theme;
  return theme.secondary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeightSemiBold;
}, (0, _spacing.space)(24), _device.device.tablet, _device.device.mobile, (0, _spacing.space)(12));